
import './App.css';
import About from './components/About';


import Home from './components/Home';
import PrintingAndPackagingERP from './components/PrintingAndPackagingERP';
import ChemicalsPaperAndRubberIndustry from './components/ChemicalsPaperAndRubberIndustry';
import AutomotiveIndustry from './components/AutomotiveIndustry';
import PharmaERP from './components/PharmaERP';
import BuildingMaterialSuppliers from './components/BuildingMaterialSuppliers';
import FoodBeverageIndustry from './components/FoodBeverageIndustry';
import TejaxoTransportationIndustryERP from './components/TejaxoTransportationIndustryERP';
import MachineryIndustryERP from './components/MachineryIndustryERP';
import TejaxoERPSoftware from './components/TejaxoERPSoftware';
import TejaxoCloudBasedERP from './components/TejaxoCloudBasedERP';
import TejaxoCRM from './components/TejaxoCRM';
import BusinessIntelligenceApplications from './components/BusinessIntelligenceApplications';
import DigitalCommerce from './components/DigitalCommerce';
import BusinessIntelligence from './components/BusinessIntelligence';
import VendorManagement from './components/VendorManagement';
import ErpImplementation from './components/ErpImplementation';
import DSC from './components/DSC';
import BioMetricsIntegration from './components/BioMetricsIntegration';
import CustManagementPortal from './components/CustManagementPortal';
import NewProductDevelopment from './components/NewProductDevelopment';
import OnlineExaminationSoftware from './components/OnlineExaminationSoftware';
import EmployeeSelfServices from './components/EmployeeSelfServices';
import TallyIntegrationSoftware from './components/TallyIntegrationSoftware';
import DocumentManagemnetSystem from './components/DocumentManagemnetSystem';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
    return (
        <Router>
            <Routes>

                <Route path="/tejaxo-erp-industries/printing-packaging" element={<PrintingAndPackagingERP />} />
                <Route path="/tejaxo-erp-industries/chemicals-paper-and-rubber-industry" element={<ChemicalsPaperAndRubberIndustry />} />
                <Route path="/tejaxo-erp-industries/automotive-industry" element={<AutomotiveIndustry />} />
                <Route path="/tejaxo-erp-industries/pharmaceuticals-industry" element={<PharmaERP />} />
                <Route path="/tejaxo-erp-industries/building-material-suppliers" element={<BuildingMaterialSuppliers />} />
                <Route path="/tejaxo-erp-industries/food-beverage-industry" element={<FoodBeverageIndustry />} />
                <Route path="/tejaxo-erp-industries/transportation-industry" element={<TejaxoTransportationIndustryERP />} />
                <Route path="/tejaxo-erp-industries/machinery-and-equipment-industry" element={<MachineryIndustryERP />} />
                <Route path="/tejaxo-erp-industries/tejaxo-erp" element={<TejaxoERPSoftware />} />
                <Route path="/tejaxo-erp-industries/tejaxo-ready-cloud-erp" element={<TejaxoCloudBasedERP />} />
                <Route path="/tejaxo-erp-industries/tejaxo-crm" element={<TejaxoCRM />} />
                <Route path="/tejaxo-erp-industries/business-intelligence-applications" element={<BusinessIntelligenceApplications />} />
                <Route path="/tejaxo-erp-industries/digital-commerce" element={<DigitalCommerce />} />
                <Route path="/tejaxo-erp-industries/business-intelligence" element={<BusinessIntelligence />} />
                <Route path="/tejaxo-erp-industries/vendor-management-portal" element={<VendorManagement />} />
                <Route path="/tejaxo-erp-industries/erp-implementation" element={<ErpImplementation />} />
                <Route path="/tejaxo-erp-industries/dsc" element={<DSC />} />
                <Route path="/tejaxo-erp-industries/bio-metrics-integration" element={<BioMetricsIntegration />} />
                <Route path="/tejaxo-erp-industries/cust-management-portal" element={<CustManagementPortal />} />
                <Route path="/tejaxo-erp-industries/new-product-developement" element={<NewProductDevelopment />} />
                <Route path="/tejaxo-erp-industries/online-test" element={<OnlineExaminationSoftware />} />
                <Route path="/tejaxo-erp-industries/employee-self-services" element={<EmployeeSelfServices />} />
                <Route path="/tejaxo-erp-industries/tally-integration" element={<TallyIntegrationSoftware />} />
                <Route path="/tejaxo-erp-industries/document-managemnet-system" element={<DocumentManagemnetSystem />} />


                <Route path="/" element={<Home />} />
                <Route path="/About" element={<About />} />
                <Route path="/Automotive_Industry" element={<AutomotiveIndustry />} />
             
                <Route path="/printing-packaging" element={<PrintingAndPackagingERP />} />
                <Route path="/chemicals-paper-and-rubber-industry" element={<ChemicalsPaperAndRubberIndustry />} />
                <Route path="/automotive-industry" element={<AutomotiveIndustry />} />
                <Route path="/pharmaceuticals-industry" element={<PharmaERP />} />
                <Route path="/building-material-suppliers" element={<BuildingMaterialSuppliers />} />
                <Route path="/food-beverage-industry" element={<FoodBeverageIndustry />} />
                <Route path="/transportation-industry" element={<TejaxoTransportationIndustryERP />} />
                <Route path="/machinery-and-equipment-industry" element={<MachineryIndustryERP />} />
                <Route path="/tejaxo-erp" element={<TejaxoERPSoftware />} />
                <Route path="/tejaxo-ready-cloud-erp" element={<TejaxoCloudBasedERP />} />
                <Route path="/tejaxo-crm" element={<TejaxoCRM />} />
                <Route path="/business-intelligence-applications" element={<BusinessIntelligenceApplications />} />
                <Route path="/digital-commerce" element={<DigitalCommerce />} />
                <Route path="/business-intelligence" element={<BusinessIntelligence />} />
                <Route path="/vendor-management-portal" element={<VendorManagement />} />
                <Route path="/erp-implementation" element={<ErpImplementation />} />
                <Route path="/dsc" element={<DSC />} />
                <Route path="/bio-metrics-integration" element={<BioMetricsIntegration />} />
                <Route path="/cust-management-portal" element={<CustManagementPortal />} />
                <Route path="/new-product-developement" element={<NewProductDevelopment />} />
                <Route path="/online-test" element={<OnlineExaminationSoftware />} />
                <Route path="/employee-self-services" element={<EmployeeSelfServices />} />
                <Route path="/tally-integration" element={<TallyIntegrationSoftware />} />
                <Route path="/document-managemnet-system" element={<DocumentManagemnetSystem />} />


              


                <Route path="/" element={<Home />} />
                <Route path="/About" element={<About />} />
                <Route path="/tejaxo-erp-industries/Automotive_Industry" element={<AutomotiveIndustry />} />
                <Route path="*" element={<Home />} />
            </Routes>
        </Router>
    );
}


export default App;